import { Component, HostListener, OnInit } from '@angular/core';
import { faMapMarkerAlt, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faLinkedinIn, faYoutube, faSpotify, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-footer',
    imports: [FaIconComponent, RouterModule, FormsModule, CommonModule, ReactiveFormsModule],
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: true
})
export class FooterComponent implements OnInit {
  expandedMenu: string | null = null;
  
  faMapMarkerAlt = faMapMarkerAlt;
  faPhone = faPhone;
  faEnvelope = faEnvelope;

  faFacebookF = faFacebookF;
  faLinkedinIn = faLinkedinIn;
  faYoutube = faYoutube;
  faSpotify = faSpotify;
  faInstagram = faInstagram;
  faWhatsapp = faWhatsapp;

  constructor() { }

  newsletterForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  ngOnInit(): void { }

  toggleMenu(event: Event, label: string) {
    event.preventDefault(); 
    this.expandedMenu = this.expandedMenu === label ? null : label;
  }
}